"use strict";

angular.module("imagetrend.components").controller("InspectionsScheduling", [
    "$scope",
    "Services",
    "$window",
    "IPVisits",
    "$q",
    "$state",
    "Cache",
    "$rootScope",
    "DataElements",
    "$timeout",
    "$compile",
    function (
        $scope,
        Services,
        $window,
        IPVisits,
        $q,
        $state,
        Cache,
        $rootScope,
        DataElements,
        $timeout,
        $compile
    ) {
        $scope.portal = $state.current.data.isPortal;
        $scope.loading = true;

        $scope.saving = false;
        $scope.services = [];
        $scope.listParams = {
            currentPage: 0,
            numPerPage: 10
        };
        $scope.bulkCreateVisits = [];
        $scope.view = "list";

        DataElements.getServiceClassification({}).then(function (classifications) {
            $scope.serviceClassificationOptions = classifications;
        })

        $scope.daysLeftInMonth = function () {
            var now = new Date();
            var endDay = new Date(
                now.getYear(),
                now.getMonth() + 1,
                0
            ).getDate();
            return endDay - now.getDate();
        };

        $scope.daysLeftInYear = function () {
            var today = new Date();
            var endofyear = new Date(today.getFullYear(), 11, 31);
            var one_day = 1000 * 60 * 60 * 24;
            return Math.ceil((endofyear.getTime() - today.getTime()) / one_day);
        };

        $scope.hideOptions = [
            {
                name: "Show when Empty",
                id: "show",
                value: false,
                display: "show when empty"
            },
            {
                name: "Hide when Empty",
                id: "hide",
                value: true,
                display: "hide when empty"
            }
        ];

        $scope.expireLengths = [
            {
                name: "Select Expires Date",
                id: 0,
                value: 0,
                display: "not selected"
            },
            { name: "This Week", id: 1, value: 7, display: "this week" },
            {
                name: "This Month",
                id: 2,
                value: $scope.daysLeftInMonth(),
                display: "this month"
            },
            {
                name: "This Year",
                id: 3,
                value: $scope.daysLeftInYear(),
                display: "this year"
            },
            {
                name: "Next 30 Days",
                id: 4,
                value: 30,
                display: "the next 30 days"
            },
            {
                name: "Next 60 Days",
                id: 5,
                value: 60,
                display: "the next 60 days"
            },
            {
                name: "Next 90 Days",
                id: 6,
                value: 90,
                display: "the next 90 days"
            },
            {
                name: "Next 120 Days",
                id: 7,
                value: 120,
                display: "the next 120 days"
            },
            {
                name: "Next 365 Days",
                id: 8,
                value: 365,
                display: "the next 365 days"
            },
            { name: "Other", id: 10, value: -1, display: "other" }
        ];

        $scope.inactiveServiceOptions = [
            { name: "Active Vehicle Records", id: "active_vehicle_records" },
            {
                name: "Active " + ($rootScope.enterprise.serviceLabels['SERVICE'] != null
                    ? $rootScope.enterprise.serviceLabels['SERVICE'] : "Service") + " Records", id: "active_service_records"
            },
            { name: "Inactive Vehicle Records", id: "inactive_vehicle_records" },
            {
                name: "Inactive " + ($rootScope.enterprise.serviceLabels['SERVICE'] != null
                    ? $rootScope.enterprise.serviceLabels['SERVICE'] : "Service") + " Records", id: "inactive_service_records"
            },
        ];

        $scope.getExpireLength = function (key) {
            if (key == null) {
                key = 0;
            }

            var expireLength;

            $scope.expireLengths.forEach(function (length) {
                if (key == length.id) {
                    expireLength = length;
                }
            });

            return expireLength;
        };

        $scope.setRange = function (start, end) {
            $scope.startDate = start;
            $scope.endDate = end;
        };

        $scope.setHideCriteria = function (hideDate) {
            $scope.hideEmptyExpireDate = hideDate;
        }
        $scope.getExpiring = function (key) {
            $scope.loading = true;

            var inactiveVehicle = false;
            var inactiveService = false;
            var activeVehicle = false;
            var activeService = false;

            if (!isUndefined($scope.inactiveCriteria) && $scope.inactiveCriteria != null) {
                if ($scope.inactiveCriteria.includes("inactive_vehicle_records")) {
                    inactiveVehicle = true;
                }
                if ($scope.inactiveCriteria.includes("inactive_service_records")) {
                    inactiveService = true;
                }
                if ($scope.inactiveCriteria.includes("active_vehicle_records")) {
                    activeVehicle = true;
                }
                if ($scope.inactiveCriteria.includes("active_service_records")) {
                    activeService = true;
                }
            }

            var length = $scope.getExpireLength(key).value;
            var rangeLength = 0;

            // if custom date range
            if (key == 10) {
                var rangeLength = Math.ceil(
                    ($scope.startDate - new Date()) / (1000 * 60 * 60 * 24)
                );
                var length = Math.ceil(
                    ($scope.endDate - new Date()) / (1000 * 60 * 60 * 24)
                );

                if (rangeLength > length) {
                    alert("Date Range is invalid");
                }
            } else {
                rangeLength = -1;
            }
            var hideEmptyExpireDate = false;
            if (!isUndefined($scope.hideEmptyExpireDate) && $scope.hideEmptyExpireDate != null) {
                if ($scope.hideEmptyExpireDate.includes("hide")) {
                    hideEmptyExpireDate = true;
                }
            }

            Services.getExpiring($scope.serviceClassification, rangeLength, length, inactiveVehicle, inactiveService, activeVehicle, activeService, hideEmptyExpireDate).then(
                function (services) {
                    if (services) {
                        services.forEach(function (service) {
                            service.vehicles.unshift({
                                id: service.id,
                                expiration_date: service.expiration_date,
                                type: "service",
                                name: service.name
                            });
                        });
                    }
                    $scope.services = services;
                    $scope.loading = false;
                }
            );
            $scope.cacheList();
        };

        Cache.getState("list").then(function (state) {
            if (state != null) {
                $scope.sortBy = state.sortBy;
                $scope.reverse = state.reverse;
                $scope.search = state.search;
                $scope.listParams.currentPage = state.currentPage;
                $scope.listParams.numPerPage = state.numPerPage;
                $scope.expireLength =
                    state.expireLength == null ? 0 : state.expireLength;
                $scope.inactiveService =
                    state.inactiveService == null
                        ? false
                        : state.inactiveService;
                $scope.inactiveCriteria = state.inactiveCriteria;
                $scope.serviceClassification = state.serviceClassification;
                $scope.hideEmptyExpireDate = state.hideEmptyExpireDate;
            } else {
                $scope.expireLength = 0;
                $scope.inactiveService = false;
                $scope.listParams.currentPage = 0;
                $scope.listParams.numPerPage = 10;
            }

            $scope.getExpiring($scope.expireLength);
        }).catch(function (response) {
            return $q.reject(response.data);
        });

        $scope.cacheList = function () {
            var state = {
                sortBy: $scope.sortBy,
                reverse: $scope.reverse,
                search: $scope.search,
                currentPage: $scope.listParams.currentPage,
                numPerPage: $scope.listParams.numPerPage,
                expireLength: $scope.expireLength,
                inactiveService: $scope.inactiveService,
                inactiveCriteria: $scope.inactiveCriteria,
                serviceClassification: $scope.serviceClassification,
                hideEmptyExpireDate: $scope.hideEmptyExpireDate,
            };

            Cache.setState("list", state);
        };

        $scope.$watch("search + expireLength", function () {
            $scope.listParams.currentPage = 0;
            $scope.cacheList();
        });

        $scope.$watch(
            "listParams.currentPage + listParams.numPerPage + sortBy + reverse",
            function () {
                $scope.cacheList();
            }
        );

        $scope.clear = function () {
            $scope.search = "";
            $scope.expireLength = 0;
            $scope.serviceClassification = [];
            $scope.inactiveCriteria = [];
            $scope.listParams.currentPage = 0;
            $scope.hideEmptyExpireDate = "show";
            $scope.cacheList();
        };

        $scope.setCounts = function (service) {
            var now = new Date();

            service.service_expired_count = 0;
            service.vehicle_expired_count = 0;

            service.vehicles.forEach(function (vehicle) {
                if (vehicle.expiration_date == null) {
                    service.has_no_expiration = true;
                    vehicle.expired = true;
                    vehicle.type == "service"
                        ? service.service_expired_count++
                        : service.vehicle_expired_count++;
                } else {
                    var expired = new Date();
                    var length = $scope.getExpireLength($scope.expireSelect)
                        .value;
                    expired.setDate(now.getDate() + length);
                    if (vehicle.expiration_date <= expired) {
                        vehicle.expired = true;
                        vehicle.type == "service"
                            ? service.service_expired_count++
                            : service.vehicle_expired_count++;

                        if (vehicle.expiration_date < now) {
                            service.has_expired = true;
                        } else {
                            service.will_expire = true;
                        }
                    } else {
                        vehicle.expired = false;
                    }
                }
            });
        };

        $scope.getDisplayString = function (service) {
            var string = "";

            if (service.service_expired_count > 0) {
                string +=
                    service.service_expired_count +
                    " " +
                    $rootScope.enterprise.serviceLabels["SERVICE"];

                if (
                    service.service_expired_count > 1 &&
                    $rootScope.enterprise.serviceLabels["SERVICE"] != null &&
                    $rootScope.enterprise.serviceLabels["SERVICE"].slice(-1) !=
                    "s"
                ) {
                    string += "s";
                }
            }
            if (
                service.vehicle_expired_count > 0 &&
                service.service_expired_count > 0
            ) {
                string += " and ";
            }
            if (service.vehicle_expired_count > 0) {
                string +=
                    service.vehicle_expired_count +
                    " " +
                    $rootScope.enterprise.vehicleLabels["VEHICLE"];

                if (
                    service.vehicle_expired_count > 1 &&
                    $rootScope.enterprise.vehicleLabels["VEHICLE"] != null &&
                    $rootScope.enterprise.vehicleLabels["VEHICLE"].slice(-1) !=
                    "s"
                ) {
                    string += "s";
                }
            }
            if (service.has_no_expiration) {
                if (
                    service.vehicle_expired_count +
                    service.service_expired_count >
                    1
                ) {
                    string += " have";
                } else {
                    string += " has";
                }
                string += " no expiration date";
            }
            if (
                service.has_no_expiration &&
                (service.will_expire || service.has_expired)
            ) {
                string += " or";
            }
            if (service.will_expire || service.has_expired) {
                string += " expire";

                if (service.has_expired && !service.will_expire) {
                    string += "d";
                } else if (
                    service.vehicle_expired_count +
                    service.service_expired_count <=
                    1
                ) {
                    string += "s";
                }
            }
            if (service.will_expire) {
                string += " in";
            }
            if (service.will_expire && service.has_expired) {
                string += " or";
            }
            if (service.has_expired) {
                string += " before";
            }

            if (service.will_expire || service.has_expired) {
                string +=
                    " " + $scope.getExpireLength($scope.expireSelect).display;
            }

            return string;
        };

        $scope.vehicleColumns = [
            {
                label:
                    $rootScope.enterprise.serviceLabels["SERVICE"] +
                    "/" +
                    $rootScope.enterprise.vehicleLabels["VEHICLE"],
                field: "name",
                info: [
                    {
                        label: "Unit Number",
                        field: "unit_number"
                    },
                    {
                        label: "Call Sign",
                        field: "call_sign"
                    }
                ]
            },
            {
                label: "Number",
                field: "number"
            },
            {
                label: "Issue Date",
                field: "issue_date",
                type: "date",
                showDashes: true,
                revertTimeZone: true
            },
            {
                label: "Expiration Date",
                field: "expiration_date",
                type: "date",
                classes: [
                    {
                        name: "red",
                        field: "expired",
                        compare: true
                    }
                ],
                showDashes: true,
                revertTimeZone: true
            },
            {
                label: "Last Inspection Date",
                field: "last_inspection_date",
                type: "date",
                showDashes: true
            }
        ];

        $scope.checkAllServices = function (event, checkAll, services) {
            event.stopImmediatePropagation();
            services.forEach(function (service) {
                service.bulkActionItems = [];
                service.vehicles.forEach(function (vehicle) {
                    vehicle.inBulkApply = checkAll;
                    if (checkAll) {
                        service.bulkActionItems.push(vehicle.id);
                    }
                });
            });
        };

        $scope.bulkCreateChange = function (services) {
            $scope.bulkCreateVisits = [];

            services.forEach(function (service) {
                var visit = {};
                visit.service_id = service.id;
                visit.service_name = service.name;
                visit.inspections = [];
                visit.inspectors = [];
                service.vehicles.forEach(function (vehicle) {
                    if (vehicle.inBulkApply) {
                        visit.inspections.push({
                            service_id: service.id,
                            vehicle_id:
                                vehicle.type == "vehicle" ? vehicle.id : null,
                            expiration_date: vehicle.expiration_date,
                            type: vehicle.type,
                            name: vehicle.name,
                            vehicle_type: vehicle.vehicle_type
                        });
                    }
                });

                if (visit.inspections.length > 0) {
                    $scope.bulkCreateVisits.push(visit);
                }
            });

            $scope.view = "edit";
            $window.scrollTo(0, 0);
        };

        $scope.changeBack = function () {
            $scope.view = "list";
            $window.scrollTo(0, 0);
        };

        $scope.setAllDates = function (date) {
            $scope.bulkCreateVisits.forEach(function (visit) {
                visit.inspection_date = angular.copy(date);
                $scope.setInspectionTime(visit);
            });
        };

        $scope.setAllTimes = function (date) {
            $scope.bulkCreateVisits.forEach(function (visit) {
                visit.inspection_date_time = angular.copy(date);
                if (visit.inspection_date == null) {
                    visit.inspection_date = new Date();
                }
                visit.inspection_date.setHours(date.getHours());
                visit.inspection_date.setMinutes(date.getMinutes());
            });
        };

        $scope.setAllInspectors = function (inspector) {
            if (inspector != null) {
                $scope.bulkCreateVisits.forEach(function (visit) {
                    if (visit.inspectors.indexOf(inspector) == -1) {
                        visit.inspectors.push(inspector);
                    }
                    if (visit.inspections !== undefined && visit.inspections != null) {
                        visit.inspections.forEach(function (inspection) {
                            inspection.inspector_id = inspector.id;
                        });
                    }
                });
                inspector = null;
            }
        };

        $scope.addInspector = function (visit) {
            if (visit.inspector != null) {
                visit.inspectors.push(angular.copy(visit.inspector));
                visit.inspector = null;
                visit.newInspector = false;
            }
        };

        $scope.remove = function (array, item) {
            array.splice(array.indexOf(item), 1);
        };

        $scope.setAllServiceChecklist = function (checklist) {
            $scope.bulkCreateVisits.forEach(function (visit) {
                visit.inspections.forEach(function (inspection) {
                    if (inspection.type == "service") {
                        inspection.template_id = checklist;
                    }
                });
            });
        };

        $scope.setAllVehicleChecklist = function (checklist) {
            $scope.bulkCreateVisits.forEach(function (visit) {
                visit.inspections.forEach(function (inspection) {
                    if (inspection.type == "vehicle") {
                        inspection.template_id = checklist;
                    }
                });
            });
        };

        $scope.save = function () {
            var promises = [];
            $scope.saving = true;

            $scope.bulkCreateVisits.forEach(function (visit) {
                visit.Date_Time_Set = (visit.inspection_date_time != null)
                promises.push(IPVisits.save(visit));
            });

            $q.all(promises).then(function () {
                if ($scope.portal) {
                    $state.go("portal.menus.inspections");
                } else {
                    $state.go("internal.inspecting.inspections");
                }
                $scope.saving = false;
            }).catch(function (response) {
                // handle error
            });
        };

        $scope.setInspectionTime = function (visit) {
            if (visit.inspection_date_time != null && isValidDate(visit.inspection_date_time)) {
                if (visit.inspection_date == null) {
                    visit.inspection_date = new Date();
                }
                visit.inspection_date.setHours(visit.inspection_date_time.getHours());
                visit.inspection_date.setMinutes(visit.inspection_date_time.getMinutes());
            }
        };
    }
]);
